import React from 'react';
import Panel from '../Panel';
import CopySection, { FinishStepButton } from '../CopySection';
import styles from './Subscribe.module.scss';
import SVGWrapper from '@components/Icons/SVGWrapper';
import { AccountIconLarge } from '@components/Integrations/AccountIcon';

const ArrowIcon = () => (
  <SVGWrapper width="19.4" height="19.4" viewBox="0 0 19.4 19.4" strokeWidth="2" customColor="#fff">
    <path
      fill="none"
      d="M13.85 12.61L13.73 5.66l-6.96-.12l6.96.12l-8.53 8.54"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVGWrapper>
);

export default function SubscribePanel({ proceedToNextStep }: { proceedToNextStep: () => void }) {
  return (
    <Panel>
      <CopySection>
        <h2>Subscribe to updates</h2>
        <p>Clay is improving each week. These are the best ways to learn about changes.</p>
        <FinishStepButton onClick={proceedToNextStep}>Let's go!</FinishStepButton>
      </CopySection>
      <div className={styles.accountTypeOptions}>
        <a
          className={styles.option}
          target="_blank"
          href="https://twitter.com/intent/follow?screen_name=clayHQ"
        >
          <AccountIconLarge providerOrType="twitter" />
          Follow us on Twitter
          <ArrowIcon />
          <div className={styles.border} />
        </a>
        <a
          className={styles.option}
          target="_blank"
          href="https://www.linkedin.com/company/clayhq/"
        >
          <AccountIconLarge providerOrType="linkedin" />
          Follow us on LinkedIn
          <ArrowIcon />
          <div className={styles.border} />
        </a>
      </div>
    </Panel>
  );
}
